import { render } from "./OutlayFilterPopup.vue?vue&type=template&id=95c712f8"
import script from "./OutlayFilterPopup.vue?vue&type=script&lang=js"
export * from "./OutlayFilterPopup.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__